export type HubSpotLifecycleStage =
  | 'subscriber'
  | 'marketingqualifiedlead'
  | 'salesqualifiedlead'
  | 'opportunity'
  | 'customer';

export type HubSpotLeadStatus =
  | 'NEW'
  | 'IN_PROGRESS'
  | 'OPEN'; // No HubSpot configurado como "Trial Expired"

export interface LifecycleEvaluationInput {
  tier?: 'free' | 'basic' | 'pro' | 'business' | string;
  isExpired?: boolean;
  isProfileComplete?: boolean;
  total_personas?: number;
  total_conversas?: number;
  loginsAfterExpired?: number;
}

export interface LifecycleEvaluationResult {
  lifecycleStage: HubSpotLifecycleStage;
  leadStatus?: HubSpotLeadStatus;
}

/**
 * Calcula o estágio do ciclo de vida (lifecyclestage) e status de vendas (hs_lead_status)
 * seguindo a régua comercial refinada da PersonaLab (Opção 2).
 */
export function calculateLifecycleStage(input: LifecycleEvaluationInput): LifecycleEvaluationResult {
  const {
    tier = 'free',
    isExpired = false,
    isProfileComplete = false,
    total_personas = 0,
    total_conversas = 0,
    loginsAfterExpired = 0,
  } = input;

  // 1. Clientes Pagantes
  if (tier === 'basic' || tier === 'pro' || tier === 'business') {
    return {
      lifecycleStage: 'customer',
    };
  }

  const hasProductEngagement = total_personas >= 1 && total_conversas >= 1;

  // 2. Trial Expirado
  if (isExpired) {
    const leadStatus: HubSpotLeadStatus = 'OPEN'; // Label "Trial Expired" no HubSpot

    // Se já fez login mais de 1 vez após o trial expirado: vira Opportunity (alta intenção comercial)
    if (loginsAfterExpired >= 2) {
      return {
        lifecycleStage: 'opportunity',
        leadStatus,
      };
    }

    // Se tiver engajamento ou perfil completo, mas expirou: vira SQL (pronto para abordagem)
    if (hasProductEngagement || isProfileComplete) {
      return {
        lifecycleStage: 'salesqualifiedlead',
        leadStatus,
      };
    }

    return {
      lifecycleStage: 'subscriber',
      leadStatus,
    };
  }

  // 3. Trial Ativo
  if (isProfileComplete && hasProductEngagement) {
    return {
      lifecycleStage: 'marketingqualifiedlead',
      leadStatus: 'IN_PROGRESS',
    };
  }

  const isStartingOut = total_personas === 0 && total_conversas === 0;

  return {
    lifecycleStage: 'subscriber',
    leadStatus: isStartingOut ? 'NEW' : 'IN_PROGRESS',
  };
}
